"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * cleanUnAllowedKeysInsideObject
 * @param {object} object2Clean object to clean
 * @param {Array<RegExp>} allowedKeys array of RegEx like: allowed: []
 * @returns {object} cleaned structure
 */
const cleanUnAllowedKeysInsideObject = (object2Clean, allowedKeys) => {
    const newObjectCleaned = Object.assign({}, object2Clean);
    // looping
    const keys = Object.keys(object2Clean);
    keys.forEach((key) => {
        let allowed = false;
        allowedKeys.forEach((regItem) => {
            const regEx = new RegExp(regItem);
            if (regEx.test(key) && !allowed) {
                allowed = true;
            }
        });
        if (!allowed) {
            delete newObjectCleaned[key];
        }
    });
    return newObjectCleaned;
};
exports.default = cleanUnAllowedKeysInsideObject;
//# sourceMappingURL=index.js.map